import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchDossiers,
  setFilters,
  updateConfirmation,
  setCurrentDossier,
  fetchDossierComplet
} from "../../redux/dispatch";
import "./Home.css";
import Loader from "../shared/Loader";
import DeleteDossierModal from "./DeleteDossierModal";






// ─── Home ─────────────────────────────────────────────────────────────────────

const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString();
};

// Pagination fenêtrée responsive : [1, "…", 5,6,7, "…", 39]
const pageWindow = (total, current) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const items = [1];
  if (current > 3) items.push("…");
  for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) items.push(i);
  if (current < total - 2) items.push("…");
  items.push(total);
  return items;
};

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { list, filters } = useSelector((s) => s.dossiers);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [gotoPage, setGotoPage] = useState("");
  const [confirmModal, setConfirmModal] = useState({ open: false, success: null, numero: "" });

  // local form state before applying
  const [localFilters, setLocalFilters] = useState({ ...filters });
  const [blockedModal, setBlockedModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const authUser = (() => { try { return JSON.parse(localStorage.getItem("nexamed_portal_user") || "null"); } catch (_) { return null; } })();
  const loadingDossier = useSelector((s) => s.formulaires.loading);
  const formulaires = useSelector((s) => s.formulaires.data);


useEffect(() => {
  setLoading(true);
  dispatch(fetchDossiers()).finally(() => setLoading(false));
}, [dispatch]);

// Le filtre porte sur TOUS les dossiers : revenir page 1 quand un filtre/limit change
useEffect(() => { setCurrentPage(1); }, [filters, limit]);

  const applyFilters = () => dispatch(setFilters(localFilters));

  const resetFilters = () => {
    const reset = {
      search: "",
      statut: "tous",
      dateDebut: "",
      dateFin: "",
      confirmation: "tous",
    };
    setLocalFilters(reset);
    dispatch(setFilters(reset));
  };

const openDossier = async (dossier) => {
/*   if (dossier.etat_confirmation !== 1) {
    setBlockedModal(true);
    return;
  } */
  dispatch(setCurrentDossier(dossier));

  await dispatch(fetchDossierComplet(dossier.id));
  navigate(`/dossier/${dossier.id}`);
};

  // ─── Filtrage ───────────────────────────────────────────────────────────────
  const filtered = list.filter((d) => {
    const search = filters.search.toLowerCase();
    if (
      search &&
      !String(d.numero_dossier || "").toLowerCase().includes(search) &&
      !String(d.patient || "").toLowerCase().includes(search) &&
      !String(d.service || "").toLowerCase().includes(search) &&
      !String(d.statut || "").toLowerCase().includes(search) &&
      !String(d.etat_confirmation).includes(search)
    )
      return false;
    if (filters.statut !== "tous" && d.statut !== filters.statut) return false;
    if (
      filters.confirmation !== "tous" &&
      d.etat_confirmation !== Number(filters.confirmation)
    )
      return false;
    if (filters.dateDebut && d.date_upload < filters.dateDebut) return false;
    if (filters.dateFin && d.date_upload > filters.dateFin) return false;
    return true;
  });

  // ─── Pagination CLIENT sur le résultat filtré (filtre GLOBAL sur tous les dossiers) ───
  const totalItems = filtered.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / limit));
  const safePage = Math.min(currentPage, totalPages);
  const pageItems = filtered.slice((safePage - 1) * limit, safePage * limit);

  const ConfirmationBtn = ({ dossier }) => {
    const dispatch = useDispatch();

    const handleConfirm = async () => {
      const result = await dispatch(updateConfirmation(dossier.id));
      const numero = dossier.numero_dossier || dossier.id;
      setConfirmModal({ open: true, success: result?.success ?? false, numero });
    };

    return (
      <button
        className={`btn-confirmer ${dossier.etat_confirmation === 1 ? "btn-confirmer--done" : ""}`}
        onClick={handleConfirm}
      >
        {dossier.etat_confirmation === 1 ? "✓ Confirmé" : "Confirmer"}
      </button>
    );
  };

  
  return (
    <div className="home-container">
      {deleteTarget && (
        <DeleteDossierModal
          dossier={deleteTarget}
          user={authUser}
          onClose={() => setDeleteTarget(null)}
          onDeleted={() => { setDeleteTarget(null); setLoading(true); dispatch(fetchDossiers()).finally(() => setLoading(false)); }}
        />
      )}
      {blockedModal && (
        <div className="modal-overlay" onClick={() => setBlockedModal(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">🔒</div>
            <h2 className="modal-title">Accès refusé</h2>
            <p className="modal-message">
              Le dossier n'est pas encore confirmé, impossible d'accéder à cette page.
            </p>
            <button className="modal-btn" onClick={() => setBlockedModal(false)}>
              Fermer
            </button>
          </div>
        </div>
      )}

      {confirmModal.open && (
        <div className="modal-overlay" onClick={() => setConfirmModal({ ...confirmModal, open: false })}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">{confirmModal.success ? "✅" : "❌"}</div>
            <h2 className="modal-title" style={{ color: confirmModal.success ? "var(--clr-success)" : "var(--clr-danger)" }}>
              {confirmModal.success ? "Confirmation réussie" : "Échec de la confirmation"}
            </h2>
            <p className="modal-message">
              {confirmModal.success
                ? `Le dossier ${confirmModal.numero} a été mis à jour avec succès.`
                : `Une erreur est survenue. Veuillez réessayer.`}
            </p>
            <button className="modal-btn" onClick={() => setConfirmModal({ ...confirmModal, open: false })}>
              Fermer
            </button>
          </div>
        </div>
      )}
      {/* ── Header ── */}
      <header className="home-header">
        <div>
          <h1 className="home-title">Portail Digital — Dossiers Médicaux</h1>
          <p className="home-subtitle">Service d'Oncologie et de Pédiatrie</p>
        </div>
      </header>

      {/* ── Filters ── */}
      <section className="filters-card">
        <div className="filters-grid">
            <div className="filter-group">
                <label>Recherche</label>
                <input
                    type="text"
                    placeholder="N° dossier, nom patient…"
                    value={localFilters.search}
                    onChange={(e) => {
                    const val = e.target.value;
                    setLocalFilters((f) => ({ ...f, search: val }));
                    dispatch(setFilters({ search: val }));
                    }}
                />
            </div>

          <div className="filter-group">
            <label>Statut</label>
            <select
              value={localFilters.statut}
              onChange={(e) =>
                setLocalFilters((f) => ({ ...f, statut: e.target.value }))
              }
            >
              <option value="tous">Tous</option>
              <option value="non_traite">Non traité</option>
              <option value="traite">Traité</option>
            </select>
          </div>

          <div className="filter-group">
            <label>Confirmation</label>
            <select
              value={localFilters.confirmation}
              onChange={(e) =>
                setLocalFilters((f) => ({ ...f, confirmation: e.target.value }))
              }
            >
              <option value="tous">Tous</option>
              <option value="0">Non confirmé</option>
              <option value="1">Confirmé</option>
            </select>
          </div>

          <div className="filter-group">
            <label>Date début</label>
            <input
              type="date"
              value={localFilters.dateDebut}
              onChange={(e) =>
                setLocalFilters((f) => ({ ...f, dateDebut: e.target.value }))
              }
            />
          </div>

          <div className="filter-group">
            <label>Date fin</label>
            <input
              type="date"
              value={localFilters.dateFin}
              onChange={(e) =>
                setLocalFilters((f) => ({ ...f, dateFin: e.target.value }))
              }
            />
          </div>
        </div>

        <div className="filters-actions">
          <button className="btn-apply" onClick={applyFilters}>
            Appliquer les filtres
          </button>
          <button className="btn-reset" onClick={resetFilters}>
            Réinitialiser
          </button>
        </div>
      </section>

      {/* ── Table ── */}
      <section className="table-card">
        {loading ? (
          <Loader />
        ) : (<>
              <table className="dossiers-table">
                <thead>
                  <tr>
                    <th>N° DOSSIER</th>
                    <th>PATIENT</th>
                    <th>SERVICE</th>
                    <th>DATE UPLOAD</th>
                    <th>HEURE</th>
                    <th>STATUT</th>
                    <th>ACTIONS</th>
                    {/* <th>CONFIRMATION</th>
                    <th>ACTION</th> */}
                  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 && (
                    <tr>
                      <td colSpan={8} className="empty-row">
                        Aucun dossier ne correspond aux filtres.
                      </td>
                    </tr>
                  )}
                  {pageItems.map((d) => (
                    <tr key={d.id} className="table-row">
                      <td>
                        <button
                          className="dossier-link"
                          onClick={() => openDossier(d)}
                        >
                      {d.numero_dossier}
                        </button>
                      </td>
                      <td>
                        <button className="dossier-link" onClick={() => openDossier(d)}>
                          {d.patient}
                        </button>
                      </td>
                      <td style={{ textTransform: 'uppercase' }}>{d.service}</td>
                      <td>{formatDate(d.date_upload)}</td>
                      <td>{d.heure}</td>
                      <td>
                        <span
                          className={`badge ${
                            d.statut === "traite" ? "badge--traite" : "badge--non-traite"
                          }`}
                        >
                          {d.statut === "traite" ? "Traité" : "Non traité"}
                        </span>
                      </td>
                      <td>
                        <button className="btn-delete-dossier" title="Supprimer ce dossier"
                          onClick={(e) => { e.stopPropagation(); setDeleteTarget(d); }}>🗑</button>
                      </td>
                     {/*  <td>
                        <span
                          className={`badge ${
                            d.etat_confirmation === 1
                              ? "badge--confirme"
                              : "badge--non-confirme"
                          }`}
                        >
                          {d.etat_confirmation === 1 ? "Confirmé" : "Non confirmé"}
                        </span>
                      </td>
                      <td>
                        <ConfirmationBtn dossier={d} />
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
        )}
      </section>
      <div className="pagination-bar">
        <div className="pagination-info">
          {totalItems > 0 && (
            <span>
              {(safePage - 1) * limit + 1}–{Math.min(safePage * limit, totalItems)} sur {totalItems} dossiers
            </span>
          )}
        </div>
        <div className="pagination-controls" style={{ flexWrap: "wrap", justifyContent: "center" }}>
          <button className="pagination-btn" onClick={() => setCurrentPage(1)} disabled={safePage === 1} title="Première page">«</button>
          <button className="pagination-btn" onClick={() => setCurrentPage(Math.max(1, safePage - 1))} disabled={safePage === 1}>‹</button>
          {pageWindow(totalPages, safePage).map((p, i) =>
            p === "…" ? (
              <span key={`e${i}`} className="pagination-ellipsis" style={{ padding: "0 6px", color: "#94a3b8" }}>…</span>
            ) : (
              <button key={p} className={`pagination-btn ${p === safePage ? "pagination-btn--active" : ""}`} onClick={() => setCurrentPage(p)}>{p}</button>
            )
          )}
          <button className="pagination-btn" onClick={() => setCurrentPage(Math.min(totalPages, safePage + 1))} disabled={safePage === totalPages}>›</button>
          <button className="pagination-btn" onClick={() => setCurrentPage(totalPages)} disabled={safePage === totalPages} title="Dernière page">»</button>
        </div>
        <div className="pagination-goto" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span>Aller à</span>
          <input type="number" min={1} max={totalPages} value={gotoPage}
            onChange={(e) => setGotoPage(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { const n = parseInt(gotoPage, 10); if (Number.isInteger(n) && n >= 1 && n <= totalPages) { setCurrentPage(n); setGotoPage(""); } } }}
            style={{ width: "62px", padding: "5px 7px", border: "1px solid #cbd5e1", borderRadius: "6px", fontSize: "13px" }} />
          <span>/ {totalPages}</span>
        </div>
        <div className="pagination-limit">
          <span>Lignes par page :</span>
          <select value={limit} onChange={(e) => { setLimit(Number(e.target.value)); setCurrentPage(1); }}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Home;